import { useState, useEffect, useRef } from "react";
import {
  Input,
  Space,
  Spin,
  Modal
} from "antd";
import translateGPT from "./controller/translateGPT";

function SentenceInterpretationInput({ record, currentLanguage, textChangeHandler, translate, gptVersion }) {
  const [rowData, setRowData] = useState(record)
  const [gptLoading, setGptLoading] = useState(false)
  const compareRef = useRef(null)

  const translateAIHandler = (e, record) => {
    e.stopPropagation();

    if (!record.sentence_text) {
      Modal.info({
        title: "문장해석",
        okText: "확인",
        content: "선택된 문장이 비어있습니다.",
      });
    } else {
      const prompt =
        `
      translate each sentences into Korean. Make sure to translate every subject for example "나는" for I, "당신은" for you, "그는" for he, "그녀는" for she and on, End a sentence in "입니다/합니다/합니까".
      - ${record.sentence_text}
      `
      setGptLoading(true)
      // translateAI(record)
      translateGPT(prompt, gptVersion)
        .then(res => {
          const newTranslateText = res[0].korean
          const instance = { ...rowData }
          instance.translate_text = newTranslateText
          textChangeHandler(instance, true)
          setGptLoading(false)
        })
        .catch(err => {
          console.log(err)
          setGptLoading(false)
        })
    }
  }

  useEffect(() => {
    setRowData(record)
  }, [JSON.stringify(record)])

  return (
    <Space style={{ justifyContent: "space-between" }}>
      <Spin spinning={gptLoading}>
        <Input.TextArea
          autoSize
          style={{
            width: "350px",
            border: rowData.existId
              ? rowData.existId_origin
                ? rowData.translate_text === rowData.translate_text_origin
                  ? ""
                  : "solid 2px red"
                : "solid 2px red"
              : "",
          }}
          defaultValue={rowData.translate_text}
          value={rowData.translate_text}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onChange={(e) => {
            const newText = e.target.value;
            const instance = { ...rowData }
            instance.translate_text = newText;
            instance.SystemSettingLanguage_code =
              currentLanguage.value;
            setRowData(instance);
          }}
          onFocus={(e) => {
            compareRef.current = rowData.translate_text;
          }}
          onBlur={() => {
            if (compareRef.current !== rowData.translate_text) {
              textChangeHandler(rowData, true)
            }
            compareRef.current = null;
          }}
        ></Input.TextArea>
      </Spin>
      <a
        style={{ whiteSpace: "pre" }}
        onClick={(e) => {
          e.stopPropagation();
          translate(rowData);
        }}
      >
        해석
      </a>
      <a
        style={{ whiteSpace: "pre" }}
        onClick={(e) => translateAIHandler(e, record)}
      >
        AI해석
      </a>
    </Space>
  )
}

export default SentenceInterpretationInput